<script lang="ts">
  import { api } from '$shared/api';

  let { id }: { id: string } = $props();

  let reason = $state('');
  let description = $state('');
  let submitted = $state(false);
  let error = $state('');
  let loading = $state(false);

  async function handleSubmit(e: Event) {
    e.preventDefault();
    if (!reason) return;
    loading = true;
    error = '';
    try {
      await api.post(`/tracks/${id}/report`, { reason, description: description.trim() });
      submitted = true;
    } catch {
      error = 'Something went wrong. Please try again.';
    }
    loading = false;
  }
</script>

<div class="report-wrapper">
  <div class="report-card">
    <h2>Report Track</h2>
    {#if submitted}
      <p class="success-msg">Report submitted. Thanks for keeping Beat Duel safe.</p>
      <a href="#/tracks/{id}" class="btn btn-primary full-width">Back to Track</a>
    {:else}
      <form onsubmit={handleSubmit}>
        <label class="field">
          <span class="field-label">Reason</span>
          <select class="input" bind:value={reason} required>
            <option value="" disabled>Select a reason</option>
            <option value="inappropriate">Inappropriate Content</option>
            <option value="copyright">Copyright Issue</option>
            <option value="spam">Spam</option>
            <option value="other">Other</option>
          </select>
        </label>
        <label class="field">
          <span class="field-label">Description</span>
          <textarea class="input" bind:value={description} rows="4" placeholder="Provide any additional details..."
          ></textarea>
        </label>
        {#if error}<p class="msg--error">{error}</p>{/if}
        <button type="submit" class="btn btn-primary full-width" disabled={loading || !reason}>
          {loading ? 'Submitting...' : 'Submit Report'}
        </button>
      </form>
      <p class="back-link"><a href="#/tracks/{id}">Back to Track</a></p>
    {/if}
  </div>
</div>

<style>
  .report-wrapper {
    display: flex;
    justify-content: center;
    padding-top: 2rem;
  }
  .report-card {
    max-width: 400px;
    width: 100%;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: 12px;
    padding: 2.5rem 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
  }
  .report-card h2 {
    text-align: center;
    color: var(--text);
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0 0 0.5rem;
    -webkit-text-fill-color: var(--text);
    background: none;
    background-clip: unset;
    -webkit-background-clip: unset;
  }
  .field {
    display: block;
  }
  .field-label {
    display: block;
    font-size: 0.875rem;
    color: var(--text-muted);
    margin-bottom: 0.25rem;
  }
  .full-width {
    width: 100%;
    padding: 0.625rem;
  }
  .input {
    max-width: 100%;
  }
  select.input {
    appearance: none;
    background: var(--bg);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: 6px;
    padding: 0.5rem 0.75rem;
    font-size: 0.9375rem;
    width: 100%;
  }
  textarea.input {
    background: var(--bg);
    color: var(--text);
    border: 1px solid var(--border);
    border-radius: 6px;
    padding: 0.5rem 0.75rem;
    font-size: 0.9375rem;
    width: 100%;
    resize: vertical;
  }
  .success-msg {
    color: var(--cyan);
    text-align: center;
    font-size: 0.9375rem;
  }
  .back-link {
    text-align: center;
    font-size: 0.875rem;
    margin-top: 0.5rem;
  }
  .back-link a {
    color: var(--cyan);
  }
</style>
